<template>
  <div class="report">
    <van-nav-bar title="会诊报告" left-arrow @click-left="$router.go(-1)"></van-nav-bar>
    <div class="wrap">
      <header class="border-bottom-1px">
        <div class="logo">
          <img :src="data.ReportLogo" />
        </div>
        <div class="info">
          <div class="title">{{data.report && data.report.title}}</div>
          <div class="des">{{data.report && data.report.smallTitle}}</div>
        </div>
      </header>
      <content>
        <ul class="Relevant border-bottom-1px">
          <li>
            <span class="left">姓名：</span>
            <span class="value">{{data.patientName}}</span>
          </li>
          <li>
            <span class="left">性别：</span>
            <span class="value">{{data.patientGender}}</span>
          </li>
          <li>
            <span class="left">年龄：</span>
            <span class="value">{{data.patientAge}}</span>
          </li>
          <!-- <li>
            <span class="left">会诊号：</span>
            <span class="value">{{data.id}}</span>
          </li> -->
          <li>
            <span class="left">申请机构：</span>
            <span class="value">{{data.organizationName}}</span>
          </li>
          <li>
            <span class="left">申请日期：</span>
            <span class="value">{{data.applyTime}}</span>
          </li>
          <li>
            <span class="left">申请医生：</span>
            <span class="value">{{data.creatorName}}</span>
          </li>
        </ul>
        <ul class="checkInfo">
          <li v-for="(item,key) in data.report && data.report.reportBlocks" :key="key">
            <p class="title">
              <span class="icon"></span>
              {{item.name}}
            </p>
            <div class="block" v-for="(center,centerKey) in item.center" :key="centerKey+'a'">
              <div v-if="center.value">
                <span>{{center.name}}：</span>
                <span>{{center.value}}</span>
              </div>
            </div>
            <div class="block" v-for="(left,leftKey) in item.left" :key="leftKey+'b'">
              <div v-if="left.value">
                <span>{{left.name}}：</span>
                <span>{{left.value}}</span>
              </div>
            </div>
            <div class="block" v-for="(right,rightKey) in item.right" :key="rightKey+'c'">
              <div v-if="right.value">
                <span>{{right.name}}：</span>
                <span>{{right.value}}</span>
              </div>
            </div>
          </li>
        </ul>
        <div class="consult-option border-bottom-1px">
          <div class="option">
            <span class="icon"></span>会诊意见：
          </div>
          <span class="optionSpan" v-for="(item,index) in data.expertDiagnosisList" :key="index">
            <span v-if="item.creatorType === 2">
              {{item.caseDiagnosisValue}}
            </span>
          </span>
          <span class="optionSpan" v-if="platformType === 2">
            <span class="consultrecord">{{data.consultRecord}}</span>
          </span>
          <div class="option" v-if="data.caseFileList && data.caseFileList.length">
            <span class="icon"></span>会诊截图：
          </div>
          <div class="img-wrap">
            <span v-for="(item2,key2) in data.caseFileList" :key="key2+'d'">
              <img v-if="Number(item2.fileType) !== 1" :src="dfsUrl + item2.fileUrl" />
              <img v-else :src=" item2.fileId ? ehrUrl + 'Gallery/ImagePath2/' + Number(item2.fileId) : '' " />
            </span>
          </div>
          <div style="clear:both"></div>
          <div style="float: right">
            <span v-if="platformType===1">审核专家签名：</span>
            <span v-else>主席签名：</span>
            <img v-if="data.hostSignature" id="Signature" :src="data.hostSignature?this.utils.getFileUrl(Number(data.hostSignature)):''" style="max-width: 90px;vertical-align: middle;" />
            <span v-else style="font-size:14px;">{{data.hostName}}</span>
          </div>
        </div>
        <footer>
          注：根据《关于推进医疗机构远程医疗服务的意见》国卫医发〔2014〕51号:“邀请方具有患者医学处置权，
          根据患者临床资料，参考受邀方的诊疗意见作出诊断与治疗决定。”本报告仅对送检数字切片负责，供申请医生参考。
        </footer>
      </content>
    </div>
  </div>
</template>

<script>
//   import headerNav from '@components/common/header-nav'

export default {
  data () {
    return {
      data: {},
      platformType: Number(this.$store.state.userInfo.platformType)
    };
  },
  created () {
    this.getData();
  },
  methods: {
    // 获取报告详情数据
    getData () {
      this.$axios
        // .post('api/consult/detail/case/preview/report', {
        .post('api/consult/detail/case/hospital/preview/report', {
          data: {
            id: this.$route.query.caseid
          },
          version: this.$version
        })
        .then((res) => {
          if (res.status) {
            if (res.data.organizationReportLogo) {
              res.data.ReportLogo = this.dfsUrl + res.data.organizationReportLogo
            } else {
              res.data.ReportLogo = this.dfsUrl + res.data.logo
            }
            if (res.data.hostSignature) {
              res.data.hostSignature = this.utils.getFileUrl(
                Number(res.data.hostSignature)
              );
            }
            this.data = res.data;
          }
        });
    }
    // 查看图片
    // openImg (key) {
    //   const imgs = this.data.ScreenShot.map(item => {
    //     return item.FilePath
    //   })
    //   this.$createImagePreview({
    //     initialIndex: key,
    //     imgs: imgs
    //   }).show()
    //   ImagePreview(['https://img.yzcdn.cn/vant/apple-1.jpg']).show()
    //   this.ImagePreview({
    //     images: imgs,
    //     showIndex: true,
    //     loop: true,
    //     startPosition: key
    //   })
    // }
  },
  components: {
    //   headerNav
  }
};
</script>

  <style lang="scss" scoped>
.consultrecord {
  white-space: break-spaces;
  word-break: break-all;
}
.border-bottom-1px {
  position: relative;
}
.report {
  min-height: calc(100vh - 52px);
  background: $white;
  position: relative;
  z-index: 1;
}
.wrap {
  width: 100%;
  padding: 0 15px;
  position: fixed;
  top: 52px;
  bottom: 0;
  overflow: auto;
  header {
    display: flex;
    height: 60px;
    margin: 10px 0;
    .logo {
      flex-basis: 60px;
      /* width: 60px;
    height: 60px; */
      img {
        width: 100%;
        height: 100%;
      }
    }
    .info {
      flex: 1;
      display: flex;
      flex-direction: column;
      text-align: center;
      justify-content: center;
      line-height: 30px;
      padding-right: 50px;
      .title {
        font-weight: bold;
        font-size: 16px;
      }
      .des {
        color: $grey;
      }
    }
  }
  content {
    display: flex;
    flex-direction: column;
    word-wrap: break-word;
    .Relevant {
      display: flex;
      flex-wrap: wrap;
      padding: 10px 0;
      box-sizing: border-box;
      li {
        display: flex;
        padding: 10px 0;
        flex-basis: 50%;
        span {
          // flex: 1;
          white-space: nowrap;
        }
        .left {
          font-weight: bold;
        }
      }
    }
    .checkInfo {
      margin-top: 10px;
      li {
        width: 100%;
        display: inline-block;
        .title {
          margin-bottom: 10px;
          font-weight: bold;
          .icon {
            width: 10px;
            height: 10px;
            border-radius: 2px;
            background-color: $black;
            display: inline-block;
            margin: 0 5px;
          }
        }
        .block {
          width: 100%;
          display: flex;
          margin-bottom: 10px;
          line-height: 20px;
          span:first-child {
            margin-right: 10px;
            flex-basis: 70px;
            text-align: right;
          }
          span:last-child {
            flex: 1;
          }
        }
      }
    }
    .consult-option {
      min-height: calc(100vh - 335px);
      margin-bottom: 10px;
      padding-bottom: 35px;
      position: relative;
      .option {
        padding: 15px 0;
        font-weight: bold;
        .icon {
          width: 10px;
          height: 10px;
          border-radius: 2px;
          background-color: $black;
          display: inline-block;
          margin: 0 5px;
        }
      }
      p {
        text-indent: 2em;
        line-height: 22px;
        white-space: break-spaces;
      }
      .img-wrap {
        span {
          display: inline-block;
          width: calc((100% - 20px) / 2);
          float: left;
          text-align: center;
          margin: 5px;
          height: 130px;
        }
        img {
          width: 100%;
          max-height: 100%;
        }
      }
      .autograph {
        width: 100%;
        position: absolute;
        bottom: 10px;
        span {
          float: right;
          height: 25px;
          line-height: 25px;
        }
        img {
          float: right;
          height: 25px;
        }
      }
    }
  }
  footer {
    height: 150px;
    line-height: 20px;
    color: $grey;
  }
}
</style>
